import i18n from "i18next";
import { initReactI18next } from "react-i18next";
// ✅ Видалено LanguageDetector

import ukTranslation from "./locales/uk.json";
import enTranslation from "./locales/en.json";

const resources = {
  uk: ukTranslation,
  en: enTranslation,
};

i18n
  .use(initReactI18next) // ✅ Без автовизначення мови
  .init({
    resources,
    fallbackLng: "uk",
    lng: localStorage.getItem("language") || "uk", // ✅ Завжди українська за замовчуванням

    interpolation: {
      escapeValue: false,
    },

    // ✅ Тільки localStorage, без визначення мови браузера
    detection: {
      order: ["localStorage"],
      caches: ["localStorage"],
    },
  });

export default i18n;
